

























import { Component, Prop, Watch, Vue, Ref } from "vue-property-decorator";
import SlidingPanel from '../_sliding-panel/sliding-panel.vue';
import { SidebarState } from '../../store';
import findElementById from '@/lib/find-element-by-id';
import { namespace } from 'vuex-class';
const sidebarState = namespace('SidebarState');
const guidedWalkthroughs = 'Guided Walkthroughs';

interface IHelpMenuLink {
    path: string
    target: string
    label: string
    visible: boolean
}

@Component({
    name: "HelpPanel",
    components: { SlidingPanel },
})
export default class HelpPanel extends Vue {
    @Prop({ required: false, default: false }) public scopelessMode: boolean;
    @sidebarState.Getter isHelpPanelOpen: boolean;
    @sidebarState.Action closeHelp: () => void;
    @sidebarState.Action toggleHelp: () => void;

    @Ref('HelpPanel') helpPanel: Vue;

    @Watch('isHelpPanelOpen', { deep: true })
    panelOpenClose(open: boolean) {
        if (open) {
            this.prepareHelpMenuLinks();
        }
    }

    public helpMenuLinks: IHelpMenuLink[] = [];

    prepareHelpMenuLinks() {
        const links = [
            {
                path: 'https://support.class.com.au/hc/en-au/signin?return_to=https%3A%2F%2Fsupport.class.com.au%2Fhc%2Fen-au',
                target: '_blank',
                label: 'Class help center',
                visible: true,
            },
            {
                path: 'javascript:openSupportRequest()',
                target: '_self',
                label: 'Classmate - chatbot',
                visible: this.scopelessMode !== true,
            },
            {
                path: 'https://training.class.com.au/',
                target: '_blank',
                label: 'Training &amp; webinars',
                visible: true,
            },
            {
                path: 'javascript:WalkMePlayerAPI.toggleMenu()',
                target: '_self',
                label: guidedWalkthroughs,
                visible: this.scopelessMode !== true,
            },
            {
                path: ' https://support.class.com.au/hc/en-au/sections/360000247996-What-s-New',
                target: '_blank',
                label: 'What\'s new',
                visible: true,
            },
            {
                path: 'https://www.class.com.au/about/what-we-do/',
                target: '_blank',
                label: 'About class',
                visible: true,
            },
        ];

        this.helpMenuLinks = links.filter(l => l.visible);
    }

    public onClickOutsideHelp(e: Event) {
        if (!this.isHelpPanelOpen) return;
        const eventTarget = e.target as HTMLElement;

        // skip - webcomponent shell.
        // another listener handling webcomponent shadow dom
        if (eventTarget.shadowRoot) return;

        const thisComponent = this.helpPanel.$el;
        const btnToggle = findElementById({
            elementId: 'help-menu-toggle',
            shadowRootToSearch: eventTarget?.shadowRoot,
            webComponentTagToSearch: 'axc-powerbar'});

        // skip - click hits the toggle button
        if (btnToggle?.contains(eventTarget)) return;

        // skip - click hits within this component
        if (thisComponent?.contains(eventTarget)) return;

        this.closeHelp();
    }

    public onClick(label: string) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (label === guidedWalkthroughs && !(<any>window)?.WalkMePlayerAPI) {
            return;
        }
        this.closeHelp();
    }

    public mounted() {
        document.querySelector('axc-powerbar')?.shadowRoot?.addEventListener('click', this.onClickOutsideHelp);
        window.addEventListener('click', this.onClickOutsideHelp);
        window.addEventListener('scroll', this.closeHelp);
    }
    public unmounted() {
        document.querySelector('axc-powerbar')?.shadowRoot?.removeEventListener('click', this.onClickOutsideHelp);
        window.removeEventListener('click', this.onClickOutsideHelp);
        window.removeEventListener('scroll', this.closeHelp);
    }

    public beforeCreate() { SidebarState.register?.(this.$store); }
    public destroyed() { SidebarState.unregister?.(this.$store); }
}
